import * as angular from "angular";
import {IController, IQService} from "angular";
import * as _ from "lodash";
import {AnalyticsService} from "../../../commons/services/analytics-service.service";
import {ResourceAllocationEditType} from "../../types/resourceAllocationEdit.type";
import {ViewSettingsModel} from "../../../commons/models/view-settings.model";
import {SiteFiltersType} from "../../../commons/types/site-filters.type";
import {QuickFilterContextService} from "../../../commons/services/quick-filter-context.service";
import {ViewFilterSettingsService} from "../../../commons/services/view-filter-settings.service";
import {ResourcesDialogService} from "../../services/resources-dialog.service";
import {ResourcesService} from "../../services/resources-service.service";
import {CommonsDialogService} from "../../../commons/services/commons-dialog.service";
import {CommonsService} from "../../../commons/services/commons-service.service";
import {ConfirmDialogService} from "../../../commons/services/confirm-dialog.service";
import {DateRangeTimeFiltersService} from "../../../commons/services/date-range-time-filters.service";
import {ScheduleDialogService} from "../../../schedule/services/schedule-dialog.service";
import {GroupModel} from "../../../groups/models/group.model";
import {BulkUpdateResourceAllocationRequest} from "../../models/Bulk-update-resource-allocation-request.model";

export class resourcesAllocationsViewCtrl implements IController {

  from: any;
  to: any;
  serviceAreaIds: string[];
  serviceAreas: any;
  branchIds: string[];
  depotIds: string[];
  accountIds: string[];
  customerIds: string[];
  groupIds: string[];
  groupsBranchIds: string[];
  viewType: string;
  agentSkills: string[];
  agentType: string;
  queryString?: string;
  tags: string[];
  allowBranchSelect: boolean;
  selectedQuickFilterId: string;
  isActive: boolean;
  dateRangeTemplateType: string;
  highlightedAllocations: any[];

  public resources: any;
  public pageName: string;
  private siteId: any;
  private allocationActionsByType: any;
  private range: any;
  private limit: number;
  private offset: any;
  private viewTypes: any;
  private agentTypes: any;
  private mainResources: any;
  private displayedResources: any; // the displayed resources in selected pagination page
  private panelAllocation: any;
  private filtersConfig: any;
  private canCreate: any;
  private canUpdate: any;
  private canDelete: any;
  private agentStatus: string;
  private pagenationPages: any;
  private allocations: any;
  public selectedResourceIds: string[] = [];

  private rrule: any;
  public page: any;
  public resourceAllocationEditTypes: typeof ResourceAllocationEditType = ResourceAllocationEditType;


  /* @ngInject */
  constructor(private resourcesDialogService: ResourcesDialogService, private resourcesService: ResourcesService, private agentConstants, private scheduleDialogService: ScheduleDialogService,
              private IAMPermissions, private confirmDialogService: ConfirmDialogService, private commonsDialogService: CommonsDialogService, private splitService, private $filter,
              private resourcesConstants, private $log, private $q: IQService, private moment, private commonsService: CommonsService,
              private analyticsService: AnalyticsService, private $state, private quickFilterContextService: QuickFilterContextService, private $groups,
              private viewFilterSettingsService: ViewFilterSettingsService, private dateRangeTimeFiltersService: DateRangeTimeFiltersService) {
    this.pageName = $state.current.name;
    this.rrule = require('rrule');
  }

  $onInit() {

    this.siteId = this.splitService.getSiteId();
    this.allocationActionsByType = this.resourcesConstants.allocationActionsByType;

    this.range = {};
    this.limit = 10;
    this.offset = 0;


    if (!this.page) {
      this.page = 0;
    }

    this.viewTypes = ['day', 'week', 'month'];
    this.agentTypes = this.agentConstants.types;

    this.mainResources = []; // All Resources
    this.displayedResources = []; // the displayed resources in selected pagination page

    this.panelAllocation = {
      template: undefined,
      allocation: undefined,
      resource: undefined,
      branchIds: undefined,
      isEdit: false,
      isCreate: false,
      isDuplicate: false
    }

    this.canCreate = this.IAMPermissions.hasPermission('fleetManagement.allocations.create');
    this.canUpdate = this.IAMPermissions.hasPermission('fleetManagement.allocations.update');
    this.canDelete = this.IAMPermissions.hasPermission('fleetManagement.allocations.delete');

    this.filtersConfig = {
      queryString: this.queryString,
      agentStatus: this.agentStatus,
      includeFilters: this.allowBranchSelect ?
        [SiteFiltersType.branchIds, SiteFiltersType.groupIds, SiteFiltersType.serviceAreaIds, SiteFiltersType.agentSkills, SiteFiltersType.isActive, SiteFiltersType.tags, SiteFiltersType.depotIds, SiteFiltersType.customerIds, SiteFiltersType.accountIds] :
        [SiteFiltersType.serviceAreaIds, SiteFiltersType.agentSkills, SiteFiltersType.isActive, SiteFiltersType.dateRangeTemplateType, SiteFiltersType.tags, SiteFiltersType.depotIds, SiteFiltersType.customerIds, SiteFiltersType.accountIds],
      bringozFilters: {
        [SiteFiltersType.dateRangeTemplateType]: this.dateRangeTemplateType,
        [SiteFiltersType.serviceAreaIds]: this.serviceAreaIds,
        [SiteFiltersType.depotIds]: this.depotIds || [],
        [SiteFiltersType.accountIds]: this.accountIds || [],
        [SiteFiltersType.customerIds]: this.customerIds || [],
        [SiteFiltersType.agentType]: this.agentType,
        [SiteFiltersType.agentSkills]: this.agentSkills,
        [SiteFiltersType.isActive]: this.isActive,
        [SiteFiltersType.tags]: this.tags || []
      },
      excludeIdsMap: {
        [SiteFiltersType.branchIds]: this.groupsBranchIds || []
      },
      queryMap: {
        tagType: 'Resource'
      }
    }

    if (this.allowBranchSelect) {
      this.filtersConfig.bringozFilters.branchIds = this.branchIds || [];
      this.filtersConfig.bringozFilters.groupIds = this.groupIds || [];
    }

    if (!this.viewType) {
      this.viewType = 'week'
    }
    this.range = {from: this.from, to: this.to};


    this._setResources();

    // if (this.resources.length) {
    //   this.mainResources = angular.copy(this.resources);
    //   this._setViewResources(this.resources);
    // }
  };

  $onChanges(changes) {
    if (changes.from && !changes.from.isFirstChange ||
      changes.to && !changes.to.isFirstChange) {
      this.range = {from: this.from, to: this.to};
    }
  };

  // ******************************
  //        Public methods
  // ******************************

  onChangeViewType(viewType) {
    if (viewType !== this.viewType) {
      this.viewType = viewType;
      this.range = this._getRangeByViewType(viewType);

      if (this.selectedQuickFilterId && this.range?.type !== this.filtersConfig.bringozFilters.dateRangeTemplateType) {
        this.selectedQuickFilterId = undefined;
      }

      this._setViewData();
    }
  }

  onDatesPageChange(isBackwards, viewType) {
    this.range = isBackwards ?
      this._getRangeBackwardsByViewType(this.range, viewType) :
      this._getRangeForewordByViewType(this.range, viewType);

    if (this.selectedQuickFilterId && this.range?.type !== this.filtersConfig.bringozFilters.dateRangeTemplateType) {
      this.selectedQuickFilterId = undefined;
    }

    this._setViewData();
  }

  onQueryChange(queryString) {
    this.filtersConfig.queryString = queryString;
    this.offset = 0;

    this.resources = _.filter(this.mainResources, (r) => {
      const logisticVehicleLicensePlateNumber = _.get(r, 'mainLogisticsVehicleReference.licensePlateNumber');
      const logisticVehicleName = _.get(r, 'mainLogisticsVehicleReference.name');

      return !queryString ||
        _.includes(_.toLower(r.name), _.toLower(queryString)) ||
        _.includes(_.toLower(logisticVehicleName), _.toLower(queryString)) ||
        _.includes(_.toLower(logisticVehicleLicensePlateNumber), _.toLower(queryString)) ||
        _.includes(_.toLower(r.agentName), _.toLower(queryString))
    });

    this._setStateParams();

    if (!!this.resources.length) {
      this._setViewResources(this.resources);
    }
  }

  onPaginationChange(page) {
    this.page = page - 1;
    this.offset = this.limit * this.page;
    this._setViewResources(this.resources);
  }

  onPaginationBrowse(isNext) {
    this.offset = isNext ? (this.offset + this.limit) : (this.offset - this.limit);
    this._setViewResources(this.resources);
  }

  isPaginationItemSelected(pageIndex) {
    return (this.offset / this.limit) === pageIndex;
  }

  onQuickFilterSelect(quickFilter: ViewSettingsModel) {
    if (!!quickFilter) {
      if (quickFilter.settings.groupIds?.length) {
        this.$groups().$asyncValues(quickFilter.settings.groupIds)
          .then((groups) => {
            let groupsBranchIds = [];
            groups.forEach((g: GroupModel) => {
              if (g.branchIds?.length) {
                groupsBranchIds = groupsBranchIds.concat(g.branchIds)
              }
            });
            this.filtersConfig.excludeIdsMap[SiteFiltersType.branchIds] = groupsBranchIds;
            quickFilter.settings[SiteFiltersType.branchIds] = _.uniq(groupsBranchIds);
            this.onFiltersChange(quickFilter.settings, quickFilter);
          })
      } else {
        this.onFiltersChange(quickFilter.settings, quickFilter);
      }
    } else {
      const filters = angular.copy(this.filtersConfig.bringozFilters);
      _.forOwn(filters, (value, key) => {
        filters[key] = _.isArray(value) ? [] : undefined;
      })
      this.onFiltersChange(filters);
    }
  }

  onFiltersChange(filters, selectedQuickFilter?) {
    this.filtersConfig.bringozFilters = filters;
    this.viewFilterSettingsService.setActiveQuickFilter(selectedQuickFilter, this.pageName);
    this.selectedQuickFilterId = selectedQuickFilter?.id;

    this._setResources();
    this._setStateParams();
  }

  onCreateResource($event) {
    const branchIds = this.allowBranchSelect ? _.get(this.filtersConfig, 'bringozFilters.branchIds') : this.branchIds;
    this.resourcesDialogService.createResource(branchIds, $event)
      .then((resourceToCreate) => {
        this._createResource(resourceToCreate);
      })
      .catch(() => {
        this.$log.info('Dialog Closed');
      })
  }

  onEditResource(resource, $event) {
    this.resourcesDialogService.editResource(resource, $event)
      .then((payload: { resource: any, addServiceAreasToTw?: boolean, autoUpdateAllocationBranches?: boolean }) => {


        if (payload.resource.agentType !== resource.agentType && payload.autoUpdateAllocationBranches) {
          this.confirmDialogService.confirm("Note",
            "Editing the agent type updates all future allocations based on the new default Agent value, and editing resource branches affects the branches of all allocations.")
            .then(() => {
              this._updateResource(payload.resource, payload.addServiceAreasToTw, !payload.autoUpdateAllocationBranches);
            });
        } else if (payload.resource.agentType === resource.agentType && payload.autoUpdateAllocationBranches) {
          this.confirmDialogService.confirm("Branches Change",
            "Editing resource branches can affect the branches of all its allocations. Do you want to continue?")
            .then(() => {
              this._updateResource(payload.resource, payload.addServiceAreasToTw , !payload.autoUpdateAllocationBranches);
            });
        } else if (payload.resource.agentType !== resource.agentType) {
          this.confirmDialogService.confirm("Agent type change",
            "Are you sure you want change Agent type? all future Allocations will be updated based on the new default Agent value")
            .then(() => {
              this._updateResource(payload.resource, payload.addServiceAreasToTw , payload.autoUpdateAllocationBranches !== undefined ? !payload.autoUpdateAllocationBranches : undefined);
            });
        } else {
          this._updateResource(payload.resource, payload.addServiceAreasToTw , payload.autoUpdateAllocationBranches !== undefined ? !payload.autoUpdateAllocationBranches : undefined);
        }
      })
      .catch(() => {
        this.$log.info('Dialog Closed');
      })
  }

  onDuplicateResource(resource, $event) {
    this.resourcesDialogService.duplicateResource(resource, $event)
      .then((payload) => {
        this._duplicateResource(resource.id, payload.name, payload.externalId);
      })
      .catch(() => {
        this.$log.info('Dialog Closed');
      })
  }

  onResourceActionsClick(resource, event) {
    let actions = this.resourcesConstants.resourceAllocationActions;

    this.commonsService.openActionPanel(actions, event)
      .then((reason: any) => {
        if (reason.key === 'ATTACH_ALLOCATION') {
          this.onOpenCreateAllocation(resource);
        }
        if (reason.key === 'EDIT_RESOURCE') {
          this.onEditResource(resource, event);
        }
        if (reason.key === 'DUPLICATE_RESOURCE') {
          this.onDuplicateResource(resource, event);
        }
        if (reason.key === 'REMOVE_RESOURCE') {
          this._onDeleteResource(resource);
        }
        if (reason.key === 'ASSIGN_AGENT_TO_ALLOCATIONS') {
          this._onAttachAgentToAllocations(resource, this.highlightedAllocations, event);
        }
      })
      .catch((reason) => {
        this.$log.info('Action Panel Closed', reason);
      });
  }

  onResourceSelect(resourceId: string, event) {
    const resourceIdIndex = this.selectedResourceIds.findIndex(rid => rid === resourceId);
    if (resourceIdIndex > -1) {
      this.selectedResourceIds.splice(resourceIdIndex, 1);
    } else {
      this.selectedResourceIds.push(resourceId);
    }
  }

  onToggleSelectAll() {
    if (!!this.selectedResourceIds.length && (this.selectedResourceIds.length === this.resources.length)) {
      this.selectedResourceIds = [];
    } else {
      this.selectedResourceIds = _.map(this.resources, 'id');
    }
  }

  onBulkEditResourceAllocation(event) {
    this.resourcesDialogService.onBulkEditResourceAllocation(event)
      .then((data) => {
        let payload = {
          gapInMinutes: undefined,
          extraTimeInMillis: undefined,
          startTime: undefined,
          durationInMillis: undefined
        };

        let durationInMillis;
        let startTimeString;

        if (data.schedule.endTime && data.schedule.startTime) {
          durationInMillis = data.schedule.endTime - data.schedule.startTime;
          startTimeString = '';
          const hour = this.moment(data.schedule.startTime).hours();
          const minutes = this.moment(data.schedule.startTime).minutes();

          if (hour < 10) {
            startTimeString += "0" + hour;
          } else {
            startTimeString += hour.toString();
          }

          startTimeString += ":";
          if (minutes < 10) {
            startTimeString += "0" + minutes;
          } else {
            startTimeString += minutes.toString();
          }

          _.set(payload, 'startTime', startTimeString)
          _.set(payload, 'durationInMillis', durationInMillis)

        }

        if (data.gapInMinutes) {
          _.set(payload, 'gapInMinutes', data.gapInMinutes)
        }

        if (data.extraTimeInMillis) {
          _.set(payload, 'extraTimeInMillis', data.extraTimeInMillis * 60000);
        }

        const queryParams = {
          freqType: data.freqType,
          from: this.range.from,
          to: this.range.to,
          resourceIds: this.selectedResourceIds
        }

        this._bulkUpdateTimeWindows(payload, queryParams);

      })
  }

  onBulkEditResources(event) {
    this.resourcesDialogService.onBulkEditResources(event)
      .then((data: BulkUpdateResourceAllocationRequest) => {
        const payload: BulkUpdateResourceAllocationRequest = data;
        payload.ids = this.selectedResourceIds;

        this._bulkUpdateResourceAllocation(payload);
      })
  }

  private _bulkUpdateTimeWindows(payload, queryParams) {
    this.resourcesService.bulkUpdateTimeWindows(payload, queryParams)
      .then(() => {
        this.selectedResourceIds = [];
        this._setViewData();
      })
  }

  private _bulkUpdateResourceAllocation(payload: BulkUpdateResourceAllocationRequest) {
    this.resourcesService.bulkUpdateResourceAllocation(payload)
      .then((updatedResources: any[]) => {
        this.selectedResourceIds = [];

        updatedResources.forEach((updatedResource) => {
          const mainResourcesIndex = _.findIndex(this.mainResources, (r: any) => {
            return r.id === updatedResource.id;
          });
          const resourceIndex = _.findIndex(this.resources, (r: any) => {
            return r.id === updatedResource.id;
          });

          if (mainResourcesIndex > -1) {
            const mainResourcesCopy = angular.copy(this.mainResources);
            mainResourcesCopy[mainResourcesIndex] = updatedResource;
            this.mainResources = mainResourcesCopy;
          }

          if (resourceIndex > -1) {
            const resourcesCopy = angular.copy(this.resources);
            resourcesCopy[resourceIndex] = updatedResource;
            this.resources = resourcesCopy;
          }
        })

        this._setViewResources(this.resources);
      })
  }

  onCreateAllocation(allocations) {
    _.forEach(allocations, (a) => {
      this._createAllocation(a.resourceAllocationId, a);
    });
    this.panelAllocation = undefined;
  }

  onUpdateAllocation(allocation, resourceAllocationEditType: ResourceAllocationEditType) {
    const selectedShiftDate = allocation.schedule.startTime;
    this._updateAllocation(allocation, resourceAllocationEditType, selectedShiftDate);
  }


  onCreateRecurringServiceSequenceToAllocation(payload, allocation, resourceAllocationEditType: ResourceAllocationEditType) {
    const selectedShiftDate = allocation.schedule.startTime;
    this._createRecurringServiceSequenceToAllocation(payload, allocation, resourceAllocationEditType, selectedShiftDate);
  }

  onOpenEditAllocation(resource, allocation, itemData) {
    // If the Panel is already open
    if (_.get(this.panelAllocation, 'allocation') && _.get(this.panelAllocation, 'isEdit')) {
      return;
    } else if (_.get(this.panelAllocation, 'allocation')) {
      this.panelAllocation.isEdit = true;
      this.panelAllocation.isCreate = false;
      this.panelAllocation.isDuplicate = false;
    } else {
      this.panelAllocation = {isEdit: true}
      var itemDataRef = itemData ? itemData : _.get(allocation, 'itemData');
      this._setPanelAllocation(allocation, resource, itemDataRef);
    }
  }

  onOpenCreateAllocation(resource, itemData?) {
    // If the Panel is already open
    if (_.get(this.panelAllocation, 'allocation') && _.get(this.panelAllocation, 'isEdit') ||
      _.get(this.panelAllocation, 'allocation') && _.get(this.panelAllocation, 'isCreate')) {
      return;
    } else {
      this.panelAllocation = {isCreate: true};
      this.onOpenPanel(undefined, resource, itemData);
    }
  }

  onOpenDuplicateAllocation(allocation, resource) {
    this.panelAllocation = {isCreate: true, isDuplicate: true};
    const allocationCopy = {
      resourceAllocationId: resource.id,
      schedule: allocation.schedule,
      locationSettings: allocation.locationSettings,
      extraTimeInMillis: allocation.extraTimeInMillis,
      gapInMinutes: allocation.gapInMinutes,
      details: allocation.details,
      serviceAreaIds: _.get(resource, 'serviceAreaIds', []),
      branchIds: allocation.branchIds,
      segments: allocation.segments,
      template: allocation.template,
      templateId: allocation.templateId,
      resourceName: resource.name
    };
    _.unset(allocation.schedule, 'exceptions');

    if (!!allocation.recurringServiceDetails) {
      this.confirmDialogService.confirm('Duplicate Allocation', 'Please note that recurring service sequence can not be included in duplicate action', event)
        .then(() => {
          this.onOpenPanel(allocationCopy, resource, undefined);
        })
    } else {
      this.onOpenPanel(allocationCopy, resource, undefined);
    }
  }

  onOpenPanel(allocation, resource, itemData) {
    // If the Panel is already open
    if (_.get(this.panelAllocation, 'allocation')) {
      if (_.get(this.panelAllocation, 'isEdit') || _.get(this.panelAllocation, 'isCreate') || _.get(this.panelAllocation, 'isTimeline')) {
        return;
      } else if (_.isEqual(_.get(this.panelAllocation, 'allocation.itemData.id'), _.get(itemData, 'id'))) {
        this.panelAllocation = undefined;
      } else {
        this._setPanelAllocation(allocation, resource, itemData);
      }
      // If the Panel is closed
    } else {
      this._setPanelAllocation(allocation, resource, itemData);
    }
  }

  onClosePanel(event, allocation) {
    if (this.panelAllocation.isEdit || this.panelAllocation.isCreate) {
      const title = this.$filter('translate')('Quit editing') + '?';
      this.confirmDialogService.confirm(title, 'Changes you have made so far will not be saved', event)
        .then(() => {
          if (this.panelAllocation.isEdit) {
            this.onOpenPanel(allocation, undefined, _.get(allocation, 'itemData'));
            this.panelAllocation.isEdit = false;
          } else {
            this.panelAllocation = undefined;
          }
        })
    } else {
      this.panelAllocation = undefined;
    }
  }

  onPanelTabSelect(selectedTab) {
    this.panelAllocation.isTimeline = !!(_.isEqual(selectedTab, 'Timeline'));
  }

  onMoveAllocation(allocationItem) {
    const allocation = angular.copy(allocationItem.ref);
    allocation.schedule.startTime = allocationItem.startTime.valueOf();
    allocation.schedule.endTime = allocationItem.endTime.valueOf();

    if (allocation.schedule.startRecurring > allocation.schedule.startTime) {
      allocation.schedule.startRecurring = allocationItem.startTime.valueOf(); //TODO: Remove?
    }
    this._updateAllocation(allocation);
  }

  onAllocationRightClick(allocation, clickedAllocationRange, itemData, hasRelatedRoutes, $event) {
    const resource = _.find(this.displayedResources, (r) => {
      return r.id === _.get(allocation, 'resourceAllocationId');
    })

    // Check if allocation agent is its resource default agent
    if (allocation.type === 'AgentSchedule') {
      if (resource && _.get(resource, 'agentId') === _.get(allocation, 'agentId')) {
        return;
      }
    }

    let actions = this.allocationActionsByType[allocation.type];

    if (!!hasRelatedRoutes) {
      actions = _.filter(actions, (a) => {
        return a.key !== 'REMOVE_ALLOCATION';
      })
    }

    if (!allocation.agentId) {
      actions = _.filter(actions, (a) => {
        return a.key !== 'UNASSIGN_AGENT';
      })
    }

    this.commonsService.openActionPanel(actions, $event)
      .then((action: any) => {
        if (_.isEqual(action.key, 'SETUP_ALLOCATION')) {
          this.onOpenEditAllocation(resource, allocation, itemData);
        }
        if (_.isEqual(action.key, 'ASSIGN_AGENT')) {
          this._onAttachAgentToAllocation(allocation, clickedAllocationRange, $event)
        }
        if (_.isEqual(action.key, 'UNASSIGN_AGENT')) {
          this._onDetachAgentToAllocation(allocation, clickedAllocationRange, $event)
        }
        if (_.isEqual(action.key, 'SEQUENCE')) {
          this._onAttachAccountSequenceToAllocation(allocation, clickedAllocationRange, $event)
        }
        if (_.isEqual(action.key, 'REMOVE_ALLOCATION')) {
          this._deleteAllocation(allocation, clickedAllocationRange, $event)
        }
        if (_.isEqual(action.key, 'REMOVE_AGENT')) {
          this._deleteAgentAllocation(allocation)
        }
        if (_.isEqual(action.key, 'DUPLICATE_ALLOCATION')) {
          this.onOpenDuplicateAllocation(allocation, resource);
        }
      })
      .catch((error) => {
        this.$log.info('Action Panel Closed', error);
      });
  }

  onHighlightAllocationsChange(allocations) {
    this.highlightedAllocations = allocations;
  }

  onExportAllocations(event) {
    const text = 'Are you sure you want to export allocations?';
    this.confirmDialogService.confirm('Export Allocations to File', text, event)
      .then(() => {
        this.analyticsService.trackEvent('Resources', 'Export', 'Confirm');
        this._onExportAllocations();
      })
      .catch((error) => {
        this.$log.info('Dialog Closed');
        this.analyticsService.trackEvent('Resources', 'Export', 'Cancel');
      });
  }

  onExportResources(event) {
    const text = 'Are you sure you want to export resources?';
    this.confirmDialogService.confirm('Export Resources to File', text, event)
      .then(() => {
        this._onExportResources();
      })
      .catch((error) => {
        this.$log.info('Dialog Closed');
      });
  }

  onExportResourcesAllocationSequences(event) {
    const text = 'Are you sure you want to export allocation sequences?';
    this.confirmDialogService.confirm('Export Allocation Sequences to File', text, event)
      .then(() => {
        this._onExportResourcesAllocationSequences();
      })
      .catch((error) => {
        this.$log.info('Dialog Closed');
      });
  }

  onUpload(event) {
    this.resourcesDialogService.upload(event)
      .then((form) => {
        this._onUpload(form);
      })
      .catch((error) => {
        if (error) {
          this.$log.error('Failed to upload file @importAllocationsButton@onUpload', error);
        } else {
          this.$log.info('Dialog Closed');
        }
      })
  }



  // ******************************
  //        Private methods
  // ******************************

  _setPanelAllocation(allocation, resource, itemData) {
    if (!this.panelAllocation) {
      this.panelAllocation = {}
    }
    this.panelAllocation.resource = resource ? resource : _.find(this.resources, (r) => {
      return r.id === allocation.resourceAllocationId;
    });

    // this.panelAllocation.branchIds = _.get(this.filtersConfig.bringozFilters.branchIds, 'length') ?
    //   this.filtersConfig.bringozFilters.branchIds :
    //   _.get(this.panelAllocation.resource, 'branchIds', []);

    // if (_.get(this.filtersConfig.bringozFilters.branchIds, 'length')) {
    //   this.panelAllocation.branchIds = this.filtersConfig.bringozFilters.branchIds
    // } else if (_.get(this.branchIds, 'length')) {
    //   this.panelAllocation.branchIds = this.branchIds;
    // } else {
    //   this.panelAllocation.branchIds = _.get(this.panelAllocation.resource, 'branchIds', []);
    // }

    this.panelAllocation.allocation = allocation ? allocation : {
      resourceAllocationId: resource.id,
      resourceName: resource.name
    };

    if (!!this.panelAllocation.allocation.branchIds?.length) {
      this.panelAllocation.branchReferences = resource.branchReferences.filter(br => this.panelAllocation.allocation.branchIds.includes(br.id));
    } else {
      this.panelAllocation.branchReferences = resource.branchReferences;
    }

    if (!_.get(this.panelAllocation.allocation, 'schedule') && itemData) {
      this.panelAllocation.allocation.schedule = {
        startTime: itemData.startDate, endTime: itemData.endDate
      };
    } else if (!!_.get(this.panelAllocation.allocation, 'schedule') && !itemData) { // for duplicate
      const todayStartOfDay = this.moment().startOf('day').valueOf();

      if (this.panelAllocation.allocation.schedule.startTime < todayStartOfDay)
        this.panelAllocation.allocation.schedule = {
          startTime: todayStartOfDay, endTime: this.moment().endOf('day').valueOf()
        };
    }

    this.panelAllocation.allocation.itemData = _.get(itemData, 'id') ? itemData : undefined;

    const isRecurring = !!allocation?.templateId && !allocation?.template && !allocation?.overridden;
    if (isRecurring) {
      this._getAllocationTemplate(resource.id, allocation.templateId);
    }

  }

  private _onExportAllocations() {
    this.resourcesService.exportAllocations(
      this.allowBranchSelect ? this.filtersConfig.bringozFilters.branchIds : this.branchIds,
      this.filtersConfig.bringozFilters.agentType,
      this.filtersConfig.bringozFilters.agentSkills,
      this.filtersConfig.bringozFilters.serviceAreaIds,
      this.filtersConfig.bringozFilters.isActive,
      this.range.from,
      this.range.to,
      this.filtersConfig.bringozFilters.tags)
      .then((res) => {

      });
  }

  private _onExportResources() {
    this.resourcesService.exportResources(
      this.allowBranchSelect ? this.filtersConfig.bringozFilters.branchIds : this.branchIds,
      this.filtersConfig.bringozFilters.agentType,
      this.filtersConfig.bringozFilters.agentSkills,
      this.filtersConfig.bringozFilters.serviceAreaIds,
      this.filtersConfig.bringozFilters.isActive,
      this.range.from,
      this.range.to,
      this.filtersConfig.bringozFilters.tags)
      .then((res) => {

      });
  }

  private _onExportResourcesAllocationSequences() {
    this.resourcesService.exportResourcesAllocationSequences(
      this.allowBranchSelect ? this.filtersConfig.bringozFilters.branchIds : this.branchIds,
      this.filtersConfig.bringozFilters.agentType,
      this.filtersConfig.bringozFilters.agentSkills,
      this.filtersConfig.bringozFilters.serviceAreaIds,
      this.filtersConfig.bringozFilters.isActive,
      this.range.from,
      this.range.to,
      this.filtersConfig.bringozFilters.tags)
      .then((res) => {

      });
  }

  _onUpload(form) {
    this.resourcesService.uploadAllocations(
      form.vehicleId,
      form.agentType,
      form.skills,
      form.file
    )
      .then((res) => {
      });
  }

  private _setResources() {
    this.offset = 0;
    this.resourcesService.getResources(
      this.allowBranchSelect ? this.filtersConfig.bringozFilters.branchIds : this.branchIds,
      this.filtersConfig.bringozFilters.agentType,
      this.filtersConfig.bringozFilters.serviceAreaIds,
      this.filtersConfig.bringozFilters.isActive,
      this.filtersConfig.bringozFilters.agentSkills,
      this.filtersConfig.bringozFilters.tags
    )
      .then((resources) => {
        this.resources = resources;
        this.mainResources = angular.copy(resources);

        if (this.filtersConfig.queryString) {
          this.onQueryChange(this.filtersConfig.queryString);
        } else {
          this._setViewResources(this.resources)
        }
      })
  }

  _getRangeByViewType(viewType) {
    const range = {from: undefined, to: undefined};

    if (viewType === 'day') {
      range.from = this.moment().startOf('day').valueOf();
      range.to = this.moment().endOf('day').valueOf()
    } else if (viewType === 'week') {
      range.from = this.moment().startOf('week').valueOf();
      range.to = this.moment().endOf('week').valueOf()
    } else if (viewType === 'month') {
      range.from = this.moment().startOf('month').valueOf();
      range.to = this.moment().endOf('month').valueOf()
    }
    return range;
  }

  _getRangeBackwardsByViewType(range, viewType) {
    var rangeCopy = angular.copy(range);
    if (viewType === 'day') {
      rangeCopy.from = this.moment(range.from).subtract(1, 'day').startOf('day').valueOf();
      rangeCopy.to = this.moment(range.to).subtract(1, 'day').endOf('day').valueOf();
    }
    if (viewType === 'week') {
      rangeCopy.from = this.moment(range.from).subtract(1, 'week').startOf('week').valueOf();
      rangeCopy.to = this.moment(range.to).subtract(1, 'week').endOf('week').valueOf();
    }
    if (viewType === 'month') {
      rangeCopy.from = this.moment(range.from).subtract(1, 'month').startOf('month').valueOf();
      rangeCopy.to = this.moment(range.to).subtract(1, 'month').endOf('month').valueOf();
    }
    return rangeCopy;
  }

  _getRangeForewordByViewType(range, viewType) {
    var rangeCopy = angular.copy(range);
    if (viewType === 'day') {
      rangeCopy.from = this.moment(range.from).add(1, 'day').startOf('day').valueOf();
      rangeCopy.to = this.moment(range.to).add(1, 'day').endOf('day').valueOf();
    }
    if (viewType === 'week') {
      rangeCopy.from = this.moment(range.from).add(1, 'week').startOf('week').valueOf();
      rangeCopy.to = this.moment(range.to).add(1, 'week').endOf('week').valueOf();
    }
    if (viewType === 'month') {
      rangeCopy.from = this.moment(range.from).add(1, 'month').startOf('month').valueOf();
      rangeCopy.to = this.moment(range.to).add(1, 'month').endOf('month').valueOf();
    }
    return rangeCopy;
  }

  _onAttachAgentToAllocation(allocation, range, $event) {

    const resource = _.find(this.resources, (r) => {
      return r.id === allocation.resourceAllocationId;
    });

    this.resourcesDialogService.attachAgentToAllocation(allocation, range, resource, resource.branchIds, $event)
      .then((payload: { agentId: string, type: ResourceAllocationEditType }) => {
        this._createAllocationBinding(resource.id, allocation, payload.type, payload.agentId, range.from.valueOf());
      })
      .catch((error) => {
        this.$log.info('Dialog Closed');
      })
  }

  _onAttachAgentToAllocations(resource, allocations, $event) {

    this.resourcesDialogService.attachAgentToAllocations(resource, allocations, $event)
      .then((payload: {
        agentId: string,
        type: ResourceAllocationEditType,
        range: { startTime: number, endTime: number }
      }) => {

        let allocationIds: string[] | undefined;
        if (!!allocations?.length) {
          allocationIds = allocations.map(a => a.id);
        }
        this._createAllocationsBinding(payload.agentId, resource.id,
          !allocations?.length ? 'RANGE' : payload.type, !allocations?.length ? payload.range : undefined, allocationIds)
      })
      .catch((error) => {
        this.$log.info('Dialog Closed');
      })
  }

  _createAllocationsBinding(agentId, resourceId, type, range?: {
    startTime: number,
    endTime: number
  }, timeWindowIds?) {
    const payload: any = {
      agentId: agentId,
      resourceAllocationId: resourceId,
      type: type
    };

    if (!!timeWindowIds) {
      payload.timeWindowIds = timeWindowIds;
    } else {
      payload.fromDate = range.startTime;
      payload.toDate = range.endTime;
    }

    this.resourcesService.bulkCreateAgentAllocationsBinding(payload)
      .then(() => {
        this._setAllocationsByResourceId(this.range.from, this.range.to, resourceId)
      })
  }

  _onDetachAgentToAllocation(allocation, range, $event) {
    const isRecurring = !!allocation.templateId && !allocation.template && !allocation.overridden;
    const functionRef = !!isRecurring ? this.scheduleDialogService.selectChangeType($event) : this.$q.when();

    functionRef
      .then((selectedChangeType) => {
        // # EVENT # FUTURE # AL
        selectedChangeType = selectedChangeType || 'EVENT';

        const resource = _.find(this.resources, (r) => {
          return r.id === allocation.resourceAllocationId;
        });

        this._detachAllocationBinding(resource.id, allocation, selectedChangeType, range.from.valueOf());
      })
      .catch((error) => {
        this.$log.info('Dialog Closed', error);
      })
  }

  _onAttachAccountSequenceToAllocation(allocation, range, $event) {

    const resource = _.find(this.resources, (r) => {
      return r.id === allocation.resourceAllocationId;
    });

    this.resourcesDialogService.attachStopSequenceToAllocation(allocation, resource, range, (this.allowBranchSelect ? this.filtersConfig.bringozFilters.branchIds : this.branchIds), $event)
      .then((updatedAllocation) => {
        this._updateAllocation(updatedAllocation);
      })
      .catch((error) => {
        this.$log.info('Dialog Closed');
      })
  }

  _createAllocationBinding(resourceId, allocation, type: ResourceAllocationEditType, agentId?, eventInstanceDate?) {
    const payload = {
      agentId: agentId,
      resourceAllocationId: allocation.resourceAllocationId,
      timeWindowId: allocation.timeWindowId,
      // templateTimeWindowsId: type === ResourceAllocationEditType.EVENT ? undefined : allocation.templateId,
      eventDate: type !== ResourceAllocationEditType.ALL ? eventInstanceDate : undefined,
      type: type
    };
    this.resourcesService.createAgentAllocationBinding(payload)
      .then(() => {
        this._setAllocationsByResourceId(this.range.from, this.range.to, resourceId)
      })
  }

  _detachAllocationBinding(resourceId: string,
                           allocation: any,
                           type: ResourceAllocationEditType,
                           eventInstanceDate?) {
    const payloadDelete = {
      resourceAllocationId: allocation.resourceAllocationId,
      timeWindowId: allocation.timeWindowId,
      // templateTimeWindowsId: type === ResourceAllocationEditType.EVENT ? undefined : allocation.templateId,
      eventDate: type !== ResourceAllocationEditType.ALL ? eventInstanceDate : undefined,
      type: type
    };
    this.resourcesService.deleteResourceAgentAllocation(payloadDelete)
      .then(() => {
        this._setAllocationsByResourceId(this.range.from, this.range.to, resourceId)
      })
  }

  _createResource(resource) {
    this.resourcesService.createResource(resource)
      .then((createdResource) => {
        // ctrl.mainResources = ctrl.mainResources.concat([createdResource]);
        // ctrl.resources = ctrl.resources.concat([createdResource]);
        this.mainResources = [createdResource].concat(this.mainResources);
        this.resources = [createdResource].concat(this.resources);
        this.displayedResources = [createdResource].concat(this.displayedResources);
      })
      .catch((error) => {
        this.$log.error('Failed to create resource '
          + '@resourcesAllocationsView@_createResource', error);
      })
  }

  _onDeleteResource(resource) {
    const header = 'Delete Resource',
      body = 'Are you sure you want to delete resource?';

    this.confirmDialogService.confirm(header, body)
      .then(() => {
        this.resourcesService.getResourceActiveRoutes(resource.id)
          .then((activeRouteIds: any) => {
            if (!!activeRouteIds?.length) {
              this.resourcesDialogService.activeRoutes(resource, activeRouteIds)
                .then(() => {
                  this._deleteResource(resource, true);
                })
                .catch(() => {
                  this.$log.info('Dialog Closed');
                })
            } else {
              this._deleteResource(resource);
            }
          })
      })
      .catch(() => {
        this.$log.info('Dialog Closed');
      })
  }

  _updateResource(resource, addServiceAreasToTw?, overrideTwBranches?) {
    this.resourcesService.updateResource(resource, resource.id, addServiceAreasToTw, overrideTwBranches)
      .then((updatedResource: any) => {
        const mainResourcesIndex = _.findIndex(this.mainResources, (r: any) => {
          return r.id === updatedResource.id;
        });
        const resourceIndex = _.findIndex(this.resources, (r: any) => {
          return r.id === updatedResource.id;
        });

        if (mainResourcesIndex > -1) {
          const mainResourcesCopy = angular.copy(this.mainResources);
          mainResourcesCopy[mainResourcesIndex] = updatedResource;
          this.mainResources = mainResourcesCopy;
        }

        if (resourceIndex > -1) {
          const resourcesCopy = angular.copy(this.resources);
          resourcesCopy[resourceIndex] = updatedResource;
          this.resources = resourcesCopy;
          this._setViewResources(resourcesCopy);
        }

        this._setAllocationsByResourceId(this.range.from, this.range.to, updatedResource.id);

      })
      .catch((error) => {
        this.$log.error('Failed to update resource @resourcesAllocationsView@_updateResource', error);
      })
  }

  _duplicateResource(resourceId, name, externalId) {
    this.resourcesService.duplicateResource(resourceId, name, externalId)
      .then((duplicatedResource: any) => {

        this.mainResources = [duplicatedResource].concat(this.mainResources);
        this.resources = [duplicatedResource].concat(this.resources);
        this.displayedResources = [duplicatedResource].concat(this.displayedResources);

        this._setAllocationsByResourceId(this.range.from, this.range.to, duplicatedResource.id);
      })
      .catch((error) => {
        this.$log.error('Failed to duplicate resource @resourcesAllocationsView@_duplicateResource', error);
      })
  }

  _deleteResource(resource, deleteActiveRelatedRoute?: boolean) {
    this.resourcesService.deleteResource(resource.id, deleteActiveRelatedRoute)
      .then(() => {
        this.resources = _.filter(this.resources, (r) => {
          return r.id !== resource.id;
        });
        this.mainResources = _.filter(this.mainResources, (r) => {
          return r.id !== resource.id;
        });
        this._setViewResources(this.resources);
      })
      .catch((error) => {
        this.$log.error('Failed to delete resource '
          + '@resourcesAllocationsView@_deleteResource', error);
      })
  }

  _createAllocation(resourceId, allocationToCreate) {
    this.resourcesService.createResourceAllocation(resourceId, allocationToCreate)
      .then((allocationCreated: any) => {
        const resourceAllocationId = _.isArray(allocationCreated) ?
          allocationCreated[0].resourceAllocationId :
          allocationCreated.resourceAllocationId;

        this._setAllocationsByResourceId(this.range.from, this.range.to, resourceAllocationId);
      })
      .catch((error) => {
        this.$log.error('Failed to create allocation', error);
      })
  }

  _updateAllocation(allocation, editType?: ResourceAllocationEditType, selectedShiftDate?: string) {

    // const itemDataRef = allocation.itemData;
    this.resourcesService.updateResourceAllocation(allocation.resourceAllocationId, allocation, editType, selectedShiftDate)
      .then((res: any) => {
        const resourceAllocationId = _.isArray(res) ?
          res[0].resourceAllocationId :
          res.resourceAllocationId;


        this._setAllocationsByResourceId(this.range.from, this.range.to, resourceAllocationId);
        this._refreshPanelAllocationAfterUpdate(resourceAllocationId, allocation, editType);
        // this.panelAllocation.allocation = _.isArray(res) ? _.find(res, ((a) => {return a.id === allocation.id})) : res;
        // this.panelAllocation.allocation.itemData = itemDataRef;
        this.panelAllocation.isEdit = false;
        this.panelAllocation.isCreate = false;
        this.panelAllocation.isDuplicate = false;
      })
      .catch((error) => {
        this.$log.error('Failed to update resource allocation', error);
      })
  }

  private _createRecurringServiceSequenceToAllocation(payload, allocation, editType?: ResourceAllocationEditType, selectedShiftDate?: string) {
    this.resourcesService.addServiceSequence(allocation.resourceAllocationId, allocation.id, payload, selectedShiftDate, editType)
      .then((res) => {
        this._setAllocationsByResourceId(this.range.from, this.range.to, allocation.resourceAllocationId);
      })
  }

  _deleteAllocation(allocation, eventRange, $event) {

    const isRecurring = !!allocation.templateId && !allocation.template && !allocation.overridden;
    const functionRef = !!isRecurring ? this.scheduleDialogService.selectChangeType($event) : this.$q.when();

    functionRef
      .then((selectedChangeType) => {
        // # EVENT # FUTURE # ALL
        let eventInstanceDate;
        selectedChangeType = selectedChangeType || 'EVENT';

        if (selectedChangeType === 'EVENT' || selectedChangeType === 'FUTURE') {
          eventInstanceDate = eventRange.from.valueOf();
        }

        // if (selectedChangeType === 'ALL') {
        //     eventInstanceDate = scheduleRef.schedule.startTime;
        // }

        return this.resourcesService.deleteResourceAllocation(allocation.resourceAllocationId, allocation.id, selectedChangeType, eventInstanceDate)
      })
      .then((deletedAllocation) => {
        this._setAllocationsByResourceId(this.range.from, this.range.to, allocation.resourceAllocationId);
      })
      .catch((error) => {
        if (error) {
          this.$log.error('Failed to delete resource allocation', error);
        } else {
          this.$log.info('Dialog Closed');
        }
      })
  }

  _deleteAgentAllocation(allocation) {
    this.resourcesService.deleteResourceAgentAllocation(allocation)
      .then(() => {
        this._setAllocationsByResourceId(this.range.from, this.range.to, allocation.resourceAllocationId);
      })
      .catch((error) => {
        this.$log.error('Failed to delete resource allocation', error);
      })
  }

  _setViewResources(resources) {
    this.pagenationPages = _.range(Math.ceil(_.get(resources, 'length', 0) / this.limit));
    this.displayedResources = _.filter(resources, (r, index) => {
      return index + 1 > this.offset && index + 1 <= this.offset + this.limit;
    });

    this._setViewData();
  }

  _setAllocationsByResourceId(from, to, resourceId) {
    this.resourcesService.getTimelineAllocations(from, to, [resourceId])
      .then((allocations) => {
        var allocationsCopy = _.filter(this.allocations, (a) => {
          return a.resourceAllocationId !== resourceId;
        })
        this.allocations = _.uniqBy(allocationsCopy.concat(allocations), 'id');
        // ctrl.mainResources = _.unionBy([allocation], ctrl.mainResources, 'id');
        // ctrl.resources = _.unionBy([allocation], ctrl.resources, 'id');


        if (!!this.panelAllocation?.allocation) {
          this.panelAllocation.allocation = _.find(this.allocations, (a) => {
            return a.id === this.panelAllocation.allocation.id;
          })
        }

      })
      .catch((error) => {
        this.$log.error('Failed to get allocation by resource', error)
      })
  }

  _setViewData() {
    this.allocations = [];

    const displayedResourceIds = _.map(this.displayedResources, 'id');
    if (!displayedResourceIds?.length) {
      return;
    }

    this._getAllocationsByResourceIds(
      this.range.from,
      this.range.to,
      displayedResourceIds,
      (this.allowBranchSelect ? this.filtersConfig.bringozFilters.branchIds : this.branchIds),
      this.filtersConfig.bringozFilters.serviceAreaIds,
      ((this.filtersConfig.bringozFilters.depotIds || []).concat(this.filtersConfig.bringozFilters.accountIds || [], this.filtersConfig.bringozFilters.customerIds || [])))
      .then((allocations) => {
        this.allocations = allocations || [];
      });
  }

  _getAllocationsByResourceIds(from, to, resourceIds, branchIds, serviceAreaIds, locationSequenceIds: string[]) {
    return this.resourcesService.getTimelineAllocations(from, to, resourceIds, branchIds, serviceAreaIds, locationSequenceIds)
      // .then(function(allocations) {
      //    ctrl.allocations = allocations || [];
      // })
      .catch((error) => {
        this.$log.error('Failed to get allocations', error)
      })
  }

  private _getAllocationTemplate(resourceId, templateId) {
    return this.resourcesService.getResourceAllocation(resourceId, templateId)
      .then((template) => {
        const isCurrentPanelTemplate = _.isEqual(_.get(this.panelAllocation, 'allocation.templateId'), templateId) ||
          _.isEqual(_.get(this.panelAllocation, 'template.id'), templateId);

        if (!!this.panelAllocation && isCurrentPanelTemplate) {
          this.panelAllocation.template = template;
        }
      })
  }

  private _refreshPanelAllocationAfterUpdate(resourceId, allocation, editType?: ResourceAllocationEditType) {
    if (!this.panelAllocation?.allocation || _.isUndefined(allocation.ignoreSegmentTimeSync)) {
      return;
    }

    this.panelAllocation.allocation = angular.extend({}, this.panelAllocation.allocation, {
      ignoreSegmentTimeSync: allocation.ignoreSegmentTimeSync
    });

    const templateId = _.get(allocation, 'templateId') || _.get(this.panelAllocation, 'template.id');

    if (!editType || editType === ResourceAllocationEditType.EVENT || !templateId || !this.panelAllocation.template) {
      return;
    }

    this.panelAllocation.template = angular.extend({}, this.panelAllocation.template, {
      ignoreSegmentTimeSync: allocation.ignoreSegmentTimeSync
    });

    this._getAllocationTemplate(resourceId, templateId);
  }

  private _setStateParams() {
    this.$state.go('.', {
      dateRangeTemplateType: this.filtersConfig.bringozFilters.dateRangeTemplateType,
      branchIds: this.filtersConfig.bringozFilters.branchIds,
      groupIds: this.filtersConfig.bringozFilters.groupIds,
      serviceAreaIds: this.filtersConfig.bringozFilters.serviceAreaIds,
      agentType: this.filtersConfig.bringozFilters.agentType,
      queryString: this.filtersConfig.queryString,
      agentSkills: this.filtersConfig.bringozFilters.agentSkills,
      isActive: this.filtersConfig.bringozFilters.isActive,
      tags: this.filtersConfig.bringozFilters.tags,
      accountIds: this.filtersConfig.bringozFilters.accountIds,
      depotIds: this.filtersConfig.bringozFilters.depotIds,
      customerIds: this.filtersConfig.bringozFilters.customerIds
    }, {notify: false, reload: false, location: 'replace'});
  }


  private _getAllocationsInstances() {
    let allAllocationItems = [];

    _.forEach(this.allocations, (a) => {

      if (a.type !== 'ResourceAllocation') {
        return;
      }

      const allocationRecurringString = _.get(a, 'schedule.rrule', '');

      if (allocationRecurringString) {
        const ruleOptions = this.rrule.RRule.parseString(allocationRecurringString);

        ruleOptions.dtstart = this.moment(a.schedule.startRecurring).utc(true).toDate()
        if (a.schedule.endRecurring) {
          ruleOptions.until = this.moment(a.schedule.endRecurring).utc(true).toDate();
        }

        const rule = new this.rrule.RRule(ruleOptions);
        let dates = rule.between(new Date(this.range.from), new Date(this.range.to));

        // convert to local
        dates = _.map(dates, (d) => {
          return this.moment(d).set({
            year: this.moment.utc(d).year(),
            month: this.moment.utc(d).month(),
            date: this.moment.utc(d).date()
          }).startOf('day').toDate();
        })

        const exceptions = _.get(a, 'schedule.exceptions', []);

        _.forEach(dates, (date) => {
          allAllocationItems.push(a)
        })

      } else {
        allAllocationItems.push(a);
      }
    });

    return allAllocationItems;
  }

}

angular
  .module('bringoz.admin.resources')
  .component('resourcesAllocationsView', {
    bindings: {
      from: '<',
      to: '<',
      serviceAreas: '<',
      serviceAreaIds: '<',
      branchIds: '<?',
      depotIds: '<?',
      accountIds: '<?',
      customerIds: '<?',
      groupIds: '<?',
      groupsBranchIds: '<',
      agentSkills: '<?',
      isActive: '<?',
      viewType: '<?',
      agentType: '<?',
      queryString: '<?',
      allowBranchSelect: '<?',
      selectedQuickFilterId: '<?',
      dateRangeTemplateType: '<?',
      tags: '<?'
    },
    template: require('./resources-allocations-view.html').default,
    controller: resourcesAllocationsViewCtrl
  });
